"use client";

import { Fragment } from "react";
import { FormattedMessage } from "react-intl";

const ITEMS = ["europe", "devices", "import", "support"] as const;

/**
 * Reassurance under the hero: four plain facts, no icons and no explanation (hosting,
 * platforms, import, reachable team). One dotted line from `lg`; stacked on phones and two
 * by two on tablets, where a wrapped dotted line would leave dots dangling at line ends.
 * The wording differs by language on purpose ("French team" in French, "European team" in
 * English).
 */
export default function TrustBand() {
  return (
    <div className="px-4 pb-16 sm:px-8 sm:pb-20">
      <p className="mx-auto grid max-w-6xl justify-items-center gap-y-1.5 text-center text-[15px] font-medium text-sec-blue 2xl:text-base sm:grid-cols-2 sm:gap-x-6 lg:flex lg:flex-nowrap lg:items-center lg:justify-center lg:gap-x-3">
        {ITEMS.map((key, k) => (
          <Fragment key={key}>
            {k > 0 && (
              <span aria-hidden="true" className="hidden text-blue-sec lg:inline">
                ·
              </span>
            )}
            {/* Wraps on phones: at 320 px the longest fact is wider than the screen. */}
            <span className="text-balance sm:whitespace-nowrap">
              <FormattedMessage id={`trust.${key}`} />
            </span>
          </Fragment>
        ))}
      </p>
    </div>
  );
}
